import Duration from './Duration'
import DurationSpan from './DurationSpan'

export default {
  install(Vue) {
    Vue.component('duration', Duration)
    Vue.component('duration-span', DurationSpan)
  },
}
